import { render } from "./GameDetail.vue?vue&type=template&id=dd9e8dee&scoped=true"
import script from "./GameDetail.vue?vue&type=script&lang=js"
export * from "./GameDetail.vue?vue&type=script&lang=js"

import "./GameDetail.vue?vue&type=style&index=0&id=dd9e8dee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd9e8dee"]])

export default __exports__